import request from '@/utils/request'


/**
 * 字典分页列表
 */
export function getDictPage(params) {
  return request({
    url: "/sys/dictionary/list",
    method: "post",
    data: params,
  });
}

/**
 * 获取字典表单数据
 *
 * @param id
 */
export function getDictFormData(id){
  return request({
    url: "/sys/dictionary/detail",
    method: "post",
    data: {
      id: id,
    },
  });
}

/**
 * 获取字典类型的数据项
 *
 * @param typeCode 字典类型编码
 */
export function getDictOptions(typeCode){
  return request({
    url: "/sys/dictionary/select",
    method: "post",
    data: {
      typeCode: typeCode,
    },
  });
}

/**
 * 新增字典
 *
 * @param data
 */
export function addDict(data) {
  return request({
    url: "/sys/dictionary/create",
    method: "post",
    data: data,
  });
}

/**
 * 修改字典项
 *
 * @param id
 * @param data
 */
export function updateDict(data) {
  return request({
    url: "/sys/dictionary/update",
    method: "post",
    data: data,
  });
}

/**
 * 删除字典
 *
 * @param id
 */
export function deleteDict(id) {
  return request({
    url: "/sys/dictionary/delete",
    method: "post",
    data: {
      id: id,
    },
  });
}

/**
 * 恢复字典有效性
 *
 * @param id
 */
export function recoverDict(id) {
  return request({
    url: "/sys/dictionary/recover",
    method: "post",
    data: {
      id: id,
    },
  });
}

